'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PictureTwoTone = _interopRequireDefault(require('./lib/icons/PictureTwoTone'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PictureTwoTone;
exports.default = _default;
module.exports = _default;